import { OnBoardingVideoDto } from '@app/data/dtos/on-boarding-video/on-boarding-video.dto';
import { OnBoardingVideo } from '@app/entities/models/on-boarding-video/on-boarding-video.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapOnBoardingVideo: MapFromFn<OnBoardingVideoDto, OnBoardingVideo> = (value) =>
  Builder.forModel(OnBoardingVideo).title(value.title).url(value.url).thumbnail(value.thumbnail).build();
